module.exports = __webpack_public_path__ + "img/N115-1.6c48594b.png";